<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Créer un patient</div>
        <div class="modal-body">
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" *ngIf="formGroup">

                <frg-form-input
                    label="Nom de naissance" id="nomNaissance" type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('nomNaissance')"
                    required="true"
                ></frg-form-input>

                <frg-form-input
                    label="Prénom de naissance" id="prenomNaissance" type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('prenomNaissance')"
                    required="true"
                ></frg-form-input>

                <frg-form-input
                    label="Date de naissance" id="dateNaissance" type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('dateNaissance')"
                    required="true"
                ></frg-form-input>

                <frg-form-input
                    label="Sexe" id="sexe" type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('sexe')"
                    required="true"
                ></frg-form-input>

                <frg-form-input
                label="Code lieu Naissance (INSEE)" id="cpNaissance" type="text"
                [formGroup]="formGroup"
                [control]="formGroup.get('cpNaissance')"
                required="true"
                ></frg-form-input>

                <frg-form-input
                    *ngIf="insType"
                    [label]="insType" id="insAndKey" type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('insAndKey')"
                    required="true"
                ></frg-form-input>

                <div class="button-wrapper">
                    <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">Annuler
                    </frg-button>
                    <frg-button [disabled]="isSubmitDisabled" [type]="'submit'" [backgroundColor]="'var(--primary)'">Créer</frg-button>
                </div>

                <!-- 
                  Règle Ségur Vague 2 / RNIV :
                  Le réseau MSSanté constitue en lui-même l'Espace de Confiance.
                  L'avertissement historique sur le "domaine d'identification" n'a plus lieu d'être.
                  L'INS doit être importé et le logiciel fera une récupération silencieuse par la suite.
                -->
            </form>

            <div *ngIf="isLoading" class="loader-wrapper">
                <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
